"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOperationAttachment = createOperationAttachment;
function cleanUrl(url) {
  return String(url || '').replace(/[?&]t=\d+(&|$)/, '$1').replace(/[?&]$/, '');
}
function getFileName(item, url) {
  var pathName = decodeURIComponent(String(url).split('/').pop() || '');
  return item.realName || item.name || item.fileName || pathName;
}
function getFileSize(item) {
  var raw = item.attSize || item.att_size || item.fileSize || item.size;
  if (typeof raw === 'number') return raw > 500 * 1024 ? raw : Math.round(raw * 1024);
  var text = String(raw || '').trim();
  var matched = text.match(/^([\d.]+)\s*(KB|MB|B)?$/i);
  if (!matched) return 1;
  var value = Number(matched[1]);
  var unit = (matched[2] || 'B').toUpperCase();
  if (unit === 'MB') return Math.round(value * 1024 * 1024);
  if (unit === 'KB') return Math.round(value * 1024);
  return Math.round(value) || 1;
}
function createOperationAttachment(item) {
  var url = cleanUrl(item.sattDir || item.attDir || item.url);
  var fileName = getFileName(item, url);
  var extName = String(fileName || url).split('.').pop().split('?')[0].toLowerCase();
  if (!['jpg', 'png', 'pdf'].includes(extName)) {
    throw new Error('附件格式仅支持JPG、PNG、PDF');
  }
  var fileSize = getFileSize(item);
  if (fileSize > 1024 * 1024) {
    throw new Error('附件大小不能超过1MB');
  }
  return {
    url: url,
    fileName: fileName,
    extName: extName,
    fileSize: fileSize
  };
}